const Inventory = {

    // FIELDS
    "inventory": "Inventory",
    "item": "Item",
    "quantity": "Quantity",
    "unit": "Unit",
    "location": "Location",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Inventory",
    "filter_title": "Inventory Filter",
    
    // TABLE HEADER
    "table_item": "Item",
    "table_quantity": "Quantity",
    "table_unit": "Unit",
    "table_location": "Location",
    
    // ERROR
    "error_item": "Select Item",
    "error_quantity": "Enter Quantity",
    "error_unit": "Select Unit",
    "error_location": "Select Location",
    "error_status": "Select Status",

}

export default Inventory;

